<template>
  <base-panel
    :hide-print-button="false"
    :asset-module="assetModule"
    :tabs="tabs"
    :last-update="lastUpdate"
    :asset="asset"
    :notifications="notifications"
  />
</template>
<script>
import { WaterOnPaperTabs } from 'sigma-mappings';
import BasePanel from '@/domain/components/installation/engineering/BasePanel';
import GeneralTab from '@/domain/components/installation/engineering/waterOnPaper/GeneralTab';
import ChartsTab from '@/domain/components/installation/engineering/waterOnPaper/ChartTab';
import ParametersTab from '@/domain/components/installation/engineering/waterOnPaper/ParametersTab';
import Service from '@/domain/services/installation/engineering/waterOnPaper/waterOnPaperService';
import eventBus from '@/services/globalEventBus';
import LoadingMixin from '@/services/loadingMixin';
import events from '@/domain/events/engineering';

export default {
  name: 'WaterOnPaper',
  props: {
    asset: {
      type: Object,
      default: () => ({}),
    },
    assetModule: {
      type: Object,
      default: () => ({}),
    },
    notifications: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [LoadingMixin],
  components: {
    BasePanel,
  },
  data: () => ({
    windingAmount: null,
    lastUpdate: '',
  }),
  computed: {
    tabs() {
      return [
        {
          name: WaterOnPaperTabs.GENERAL,
          title: this.$t('general.general'),
          component: GeneralTab,
          windingAmount: this.windingAmount,
        },
        {
          name: WaterOnPaperTabs.PARAMETERS,
          title: this.$t('general.parameters'),
          component: ParametersTab,
          windingAmount: this.windingAmount,
        },
        {
          name: WaterOnPaperTabs.CHART,
          title: this.$t('general.chart'),
          component: ChartsTab,
          windingAmount: this.windingAmount,
        },
      ];
    },
  },
  created() {
    this.getWaterOnPaperStatus(true);
    this.initListener();
  },
  beforeDestroy() {
    this.removeListener();
  },
  methods: {
    getWaterOnPaperStatus(showLoading) {
      return Service.getStatus(this.assetModule.id).then((response) => {
        this.windingAmount = response.windingAmount;
        this.lastUpdate = response.lastUpdate;
      }).then(() => {
        eventBus.emit(events.refreshDataTab, showLoading);
      }).catch(() => {
        this.windingAmount = 0;
      });
    },
    initListener() {
      eventBus.on(events.refreshData, this.refreshDataEvent, this);
    },
    removeListener() {
      eventBus.off(events.refreshData, this.refreshDataEvent, this);
    },
    refreshDataEvent({ wait }) {
      wait(this.getWaterOnPaperStatus());
    },
  },
};
</script>

<style lang="sass" scoped>
  @media print
    ::v-deep .tabs > .tab-content > .tab-pane
      border-bottom: none
</style>
